
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class CodeBoxDialog extends Vue {
  @Prop()
  open!: boolean;
}
